export default __webpack_public_path__ + "static/media/Aboutgraphics.748b5c90.png";